module.exports = __webpack_public_path__ + "statics/img/demo.236f8ddd.png";